import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IReport } from "./domain/IReport";
import { reportsService } from "./services/reports.service";

export const deleteReport = createAsyncThunk(
  "Reports/deleteReport",
  async (reportId: number) => {
    try {
      return await reportsService.deleteReport(reportId);
    } catch (err) {
      setError(err);
    }
  }
);

interface ReportsState {
  loading: boolean;
  reports: IReport[];
  deleteReportModalOpen: boolean;
  reportForDeletion: number;
  error: any;
};

const initialState: ReportsState = {
  loading: false,
  reports: [],
  deleteReportModalOpen: false,
  reportForDeletion: -1,
  error: null,
};

export const reportsSlice = createSlice({
  name: "reports",
  initialState: initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setDeleteReportModalOpen: (
      state,
      action: PayloadAction<{ visible: boolean, index: number }>) => {
      state.deleteReportModalOpen = action.payload.visible;
      state.reportForDeletion = action.payload.index;
    },
    deleteReportById: (state, action: PayloadAction<number>) => {
      if (action.payload) {
        state.reports = state.reports.filter(report =>
          report.reportId !== action.payload
        );
      }
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    }
  },
  extraReducers: (builder) => {
  },
});

export const selectState = (state: RootState) => state.reports;
export const selectReportForDeletion = (state: RootState) =>
  state.reports.reports[state.reports.reportForDeletion];

export const {
  setLoading,
  setDeleteReportModalOpen,
  deleteReportById,
  setError,
} = reportsSlice.actions;

export default reportsSlice.reducer;
